import React from "react";
import ReactECharts from "echarts-for-react";

const EnergyAuditReportDonutChart: React.FC = () => {
  const options = {
    tooltip: {
      trigger: "item",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      formatter: (params: any) => `
        <div style="padding: 5px; color: #fff;">
        ${params.data.name}: ${params.data.value}%
        </div>
      `,
    },
    legend: {
      orient: "vertical",
      bottom: "60",
      right: "30",
      data: ["DT-101", "DT-102", "DT-103", "DT-104", "DT-105"],
      textStyle: {
        fontFamily: "Figtree",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 11.72,
        letterSpacing: "0.02em",
        color: "#4C5269",
        textAlign: "left",
      },
      itemWidth: 15,
      itemHeight: 15,
    },
    series: [
      {
        name: "Dataset",
        type: "pie",
        radius: ["50%", "70%"],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: "#fff",
          borderWidth: 2,
        },
        label: {
          show: false,
          position: "center",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: "16",
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: [
          { value: 40, name: "DT-101" },
          { value: 30, name: "DT-102" },
          { value: 25, name: "DT-103" },
          { value: 20, name: "DT-104" },
          { value: 15, name: "DT-105" },
        ],
      },
    ],
    color: ["#29CBFF", "#3b82f6", "#1e40af", "#6366f1", "#a855f7"],
  };

  return (
    <ReactECharts option={options} style={{ height: "260px", width: "100%" }} />
  );
};

export default EnergyAuditReportDonutChart;
